import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { dataModel } from './ReviewDataModel';
import { RatingsAndReviewsDefaultProps, RatingsAndReviewsPropTypes } from './RatingsAndReviewsPropTypes';

const placeholder = (
  <div data-component="RatingsAndReviewsCondensedImporterPlaceholder">
    <LoadingPlaceholder
      color="#f5f5f5"
      ready={false}
      style={{ height: 750 }}
      type="rect"
    >
      <div />
    </LoadingPlaceholder>
  </div>
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./RatingsAndReviewsCondensed')).RatingsAndReviewsCondensed;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews-condensed" */
      './RatingsAndReviewsCondensed');
  },
  placeholder,
  name: 'RatingsAndReviewsCondensed'
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'product-section-rr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const RatingsAndReviewsCondensedImporter = withErrorBoundary(DynamicComponent);

RatingsAndReviewsCondensedImporter.displayName = 'RatingsAndReviewsCondensedImporter';
RatingsAndReviewsCondensedImporter.propTypes = RatingsAndReviewsPropTypes;
RatingsAndReviewsCondensedImporter.defaultProps = RatingsAndReviewsDefaultProps;
RatingsAndReviewsCondensedImporter.dataModel = dataModel;
